import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { addToCart, removeFromCart, updateQuantity, clearCart } from '../store/slices/cartSlice';
import { Product } from '../api/storeApi';

export type CartItem = Product & { quantity: number };

export const useCart = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state: RootState) => state.cart.items);

  const addItem = useCallback((product: Product) => {
    dispatch(addToCart(product));
  }, [dispatch]);

  const removeItem = useCallback((id: number) => {
    dispatch(removeFromCart(id));
  }, [dispatch]);

  const updateItemQuantity = useCallback((id: number, quantity: number) => {
    dispatch(updateQuantity({ id, quantity }));
  }, [dispatch]);

  const clear = useCallback(() => {
    dispatch(clearCart());
  }, [dispatch]);

  const total = cartItems.reduce((sum, item) => sum + item.mrp * item.quantity, 0);

  return {
    items: cartItems,
    total,
    addItem,
    removeItem,
    updateItemQuantity,
    clear,
  };
};
